import React from 'react';
import DOMPurify from 'dompurify';

export const HTMLDiv=({
    html,
    className,
    style,
    onClick
})=>{
    return (
        <div
            style = {style}
            onClick={onClick}
            className={className}
            dangerouslySetInnerHTML={{
                __html : DOMPurify.sanitize(html)
            }}
        />
    )
}